<template>
  <div class="table_container" v-if="tbody">
    <el-table :data="tbody" border scrollbar-always-on max-height="505" empty-text="暂无数据" style="width:100%">
      <el-table-column fixed type="index" label="序号" label-class-name="th1" align="center" width="38" />
      <template v-for="(item,index) in thead" :key="item.colName">
        <el-table-column v-if="item.colName=='期别'" fixed :prop="item.colStr" :label="item.colName" label-class-name="th1" align="center" :width="computColWidth(tbody[0][item.colStr],'期别')" />
        <el-table-column v-else-if="item.colName=='地区'" fixed :prop="item.colStr" :label="item.colName" label-class-name="th1" align="center" width="100" />
        <el-table-column v-else :prop="item.colStr" label-class-name="th2">
          <template #header>
            <el-checkbox v-model="checkedList[item.colCode]" @change="(val)=>checkboxClick(item,val)" />
            <span class="thead-th_text">{{ item.colName }}</span>
          </template>
          <template v-if="item.periods && item.periods.length>0">
            <el-table-column v-for="period in item.periods" :prop="period.colStr" :label="period.colName" label-class-name="th2_2" :class-name="checkedList[item.colCode]?'selected':''" :width="computColWidth(period.colName)" />
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script setup>
  import { ElTable, ElTableColumn, ElCheckbox } from 'element-plus';
  import { computed, ref, toRefs, watch } from 'vue-demi';

  const emits = defineEmits();
  const props = defineProps({
    thead: { type: Array, default: [] },
    tbody: { type: Array, default: [] },
  });
  const { thead, tbody } = toRefs(props);
  let checkedList = ref({});

  const checkboxClick = (item, val) => {
    checkedList.value[item.colCode] = val;
    emits('theadCheck', checkedList.value);
  };
  // 计算列的宽度
  const computColWidth = (str, type) => {
    if (type == '期别') {
      console.log(str.length * 12);
      return str.length * 15;
    } else {
      return str.length > 5 ? str.length * 20 : 100;
    }
  };

  const tableData = computed(() => {
    return { theadData: thead.value, tbodyData: tbody.value };
  });

  watch(
    () => tableData.value,
    (nv) => {
      const { theadData } = nv;
      if (theadData && theadData.length > 1) {
        checkedList.value = {};
        checkedList.value[theadData[1]['colCode']] = true;
      }
    },
    { deep: true }
  );
</script>

<style lang="less" scoped>
  .table_container {
    width: 850px;
    height: 525px;
    padding-top: 5px;
    padding-left: 0px;
    padding-right: 0px;
    font-size: 12px;
    margin: 0 auto;

    :deep(.el-table) {
      --box-height: 36px;
      --el-table-border: 1px solid var(--bd-color);
      --el-table-border-color: var(--bd-color);
      // --el-table-tr-bg-color: #f9f9f9;
      --el-fill-color-lighter: #f2fbfd;
      // --el-bg-color: #f9f9f9;
      thead {
        .cell {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          font-weight: normal;
          font-weight: 600;
        }
        .thead-th_text {
          padding-left: 4px;
        }
      }
      tbody {
        th,
        td {
          padding: 8px;
          line-height: 1.42857;
          vertical-align: middle;
        }
        th,
        td:not(.is-center) {
          text-align: right;
        }
      }
      tr > th {
        font-weight: 100;
      }
      &.el-table--border .el-table__cell:first-child .cell {
        padding-left: 0;
      }
      .cell {
        padding: 0;
        white-space: nowrap;
        text-overflow: inherit;
      }
      .el-table__cell {
        height: var(--box-height);
        padding: 0 5px;
        font-size: var(--base-font-size);
        color: #333;
        &.th2 {
          background-color: #d9e6fd;
        }
        &.th1,
        &.th2_2 {
          background-color: #ebf1fd;
        }
        .el-checkbox {
          height: var(--box-height);
        }
      }
      .selected:not(.th2_2) {
        background-color: #f5f8fe !important;
      }

      .el-scrollbar__bar.is-horizontal {
        height: 8px;
      }
      .el-scrollbar__bar.is-vertical {
        width: 8px;
      }
      .el-scrollbar__thumb {
        --el-scrollbar-bg-color: #44474b;
      }

      .el-checkbox {
        --el-checkbox-checked-bg-color: var(--light-color);
        --el-checkbox-checked-input-border-color: var(--light-color);
      }
    }
  }
</style>